// DOM selectors
export const CONTENT_CONTAINER_SELECTOR = '.tc-container'; // main article content container

// timing constants
export const DEBOUNCE_MS = 100;
